module.exports = __webpack_public_path__ + "img/horizontal_3_5_5010.9eeb5170.png";